import React from 'react'
import Table from '@material-ui/core/Table'
import TableBody from '@material-ui/core/TableBody'
import TableCell from '@material-ui/core/TableCell'
import TableContainer from '@material-ui/core/TableContainer'
import TableRow from '@material-ui/core/TableRow'

interface EmissionByType {
  totalCalculatedEmissions: number
  calculatedEmissionPerPerson: number
  journeyType: string
}

interface EmissionTableProps {
  emissionsByJourneyType: EmissionByType[]
  totalCalculatedEmissionPerPerson: number
}

const jouneyTypeDisplayName = {
  DRIVING: '🚗 Car',
  WALKING: '👟 Walk',
  CYCLING: '🚲 Bike',
  TRAIN: '🚆 Train',
  PLANE: '✈️ Plane',
  BUS: '🚌 Bus',
}

const EmissonBar: React.FC<{width: number}> = ({ width }) => {
  // the maximun width of bar is 1/5 (20%) of table cell
  return <hr
    style={{
      display: 'inline-block',
      color: '#187759',
      backgroundColor: '#187759',
      marginInline: '8px',
      height: 5,
      width: `${width * 20}%`,
      borderRadius: '5px',
    }}
  />
}

const roundToTwo = (num): number => {
  return Math.round(num * 100) / 100
}

export const EmissionTable: React.FC<EmissionTableProps> = ({ emissionsByJourneyType, totalCalculatedEmissionPerPerson }) => {
  return (
    <TableContainer>
      <Table size="small" aria-label="a dense table">
        <TableBody>
          {emissionsByJourneyType?.map(({ journeyType, totalCalculatedEmissions, calculatedEmissionPerPerson }) => (
            <TableRow key={journeyType} >
              <TableCell component="th" scope="row" style={{ width: 80, border: 'none', fontFamily: 'Montserrat', fontWeight: 600, fontSize: 14, padding: 6 }}>
                {jouneyTypeDisplayName[journeyType]}
              </TableCell>
              <TableCell style={{ display: 'flex', border: 'none', fontFamily: 'Montserrat', fontWeight: 500, fontSize: 14, padding: 6 }}>
                <EmissonBar width={roundToTwo(calculatedEmissionPerPerson / totalCalculatedEmissionPerPerson)} />
                {roundToTwo(calculatedEmissionPerPerson)}
                kg per person
                {['WALKING', 'CYCLING'].includes(journeyType) ? <span> 🎉 </span> : <></> }
              </TableCell>
              <TableCell align="right" style={{ border: 'none', fontFamily: 'Montserrat', fontWeight: 500, fontSize: 14 }}>
                {roundToTwo(totalCalculatedEmissions)}kg total
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  )
}
